<template>
  <vx-card>
    <div class="vx-row mb-6">
      <vs-button
        class="ml-4 mt-2"
        color="danger"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="handleBack()"
      >Back
      </vs-button>
    </div>

    <div class="flex md:flex-row">
      <div class="w-full pr-6 md:basis-1/2">
        <div class="mb-6 vx-row">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Change Batch ID</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <vs-input class="w-full bg-grey-light" :value="code" disabled readonly></vs-input>
          </div>
        </div>

        <div class="mb-6 vx-row">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Warehouse Code</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <vs-input class="w-full bg-grey-light" :value="warehouseCode" disabled readonly></vs-input>
          </div>
        </div>

        <div class="mb-6 vx-row">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Note</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <vs-textarea class="w-full bg-grey-light" :value="note" disabled readonly/>
          </div>
        </div>

      </div>

      <div class="w-full md:basis-1/2">
        <div class="mb-6 vx-row">
          <vs-divider style="width: 50%; margin-left: 10%">
            List Attachment
          </vs-divider>
          <div
            class="vx-row mb-3 mt-6 w-4/4"
            style="width: 50%; margin-left: 10%"
          >
            <table class="vs-table vs-table--tbody-table">
              <template>
                <tr
                  class="tr-values vs-table--tr tr-table-state-null selected"
                  v-bind:key="tr.NameFile"
                  v-for="tr in fileAttachment"
                >
                  <td class="td vs-table--td">{{ tr.FileName }}</td>
                  <td class="td vs-table--td">
                    <vx-tooltip text="Show" v-if="tr.Path != ''">
                      <vs-button
                        type="line"
                        icon-pack="feather"
                        icon="icon-eye"
                        @click.stop="handleShowAttachment(tr.FileUrl)"
                      />
                    </vx-tooltip>
                  </td>

                </tr>
              </template>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col sm:w-5/5 w-full mb-2" v-for="(tr, indextr) in items" :key="indextr">

      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">
          <div class="vx-col w-6/12">
            <label class="vs-input--label">Warehouse Area</label>
          </div>
          <div class="vx-col w-6/12">
            <label class="vs-input--label">SKU</label>
          </div>
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-6/12">
          <vs-input class="w-full bg-grey-light" :value="tr.warehouseArea" disabled readonly></vs-input>
        </div>
        <div class="vx-col w-6/12">
          <vs-input class="w-full bg-grey-light" :value="tr.sku" disabled readonly></vs-input>
        </div>
      </div>

      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">

          <div class="vx-col w-3/12">
            <label class="vs-input--label">Batch External / ED</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">Date IN</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Handling Unit</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Available Qty</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Available Qty UOM</label>
          </div>

        </div>

        <div class="vx-row mb-2">

          <div class="vx-col w-3/12">
            <vs-input class="w-full bg-grey-light" :value="tr.batchExternal" disabled readonly></vs-input>
          </div>

          <div class="vx-col w-2/12">
            <vs-input class="w-full bg-grey-light" :value="tr.dateIn" disabled readonly></vs-input>
          </div>

          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="tr.hu" disabled readonly></vs-input>
          </div>

          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="tr.availableQty" disabled readonly></vs-input>
          </div>

          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="tr.availableQtyUom" disabled readonly></vs-input>
          </div>
        </div>
      </div>

      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">

          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Handling Unit</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Qty</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Qty UOM</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">New Batch External</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">New Expired Date</label>
          </div>

        </div>

        <div class="vx-row mb-2" v-for="(newLine, idx) in tr.newLines" :key="idx">
          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="newLine.newUnit" disabled readonly></vs-input>
          </div>
          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="newLine.newQty" disabled readonly></vs-input>
          </div>
          <div class="vx-col w-1/12">
            <vs-input class="w-full bg-grey-light" :value="newLine.newQtyUom" disabled readonly></vs-input>
          </div>
          <div class="vx-col w-2/12">
            <vs-input class="w-full bg-grey-light" :value="newLine.newBatchExternal" disabled readonly></vs-input>
          </div>
          <div class="vx-col w-2/12">
            <vs-input class="w-full bg-grey-light" :value="newLine.newExpiredDate" disabled readonly></vs-input>
          </div>
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-1/12"></div>
        <div class="vx-col w-1/12"></div>
        <div class="vx-col w-1/12">
          <label class="vs-input--label">Total New Qty UOM</label>
          <vs-input class="w-full bg-grey-light" :value="getTotalNewQtyUom(tr)" disabled readonly></vs-input>
        </div>
      </div>

      <vs-divider></vs-divider>
    </div>
    <br/>

  </vx-card>
</template>

<script>
import Attachment from './component/Attachment.vue'
import moment from "moment";

export default {
  components: {Attachment},
  data() {
    return {
      id: this.$route.query.id ? parseInt(this.$route.query.id) : null,
      code: null,
      warehouseCode: null,
      countingDate: null,
      note: null,
      fileAttachment: [],
      items: [],
    }
  },
  methods: {
    getTotalNewQtyUom(tr) {
      return tr.newLines.reduce((sum, line) => sum + (line.newQtyUom || 0), 0);
    },
    handleBack() {
      this.$router.push({
        name: "manage-change-batch",
        query: {tab: this.$route.query.tab},
      });
    },
    getData() {
      this.$vs.loading();
      this.$http.get("/api/wms/v1/change-batch/" + this.id).then((resp) => {
        if (resp.code === 200) {
          this.$vs.loading.close();
          this.code = resp.data.change_batch.Code;
          this.warehouseCode = resp.data.change_batch.WarehouseCode + " - " + resp.data.change_batch.WarehouseName;
          this.note = resp.data.change_batch.Note;
          this.fileAttachment = resp.data.change_batch_attachments;

          this.items = resp.data.change_batch_lines.map(items => ({
            warehouseArea: items.warehouse_area_code + " - " + items.warehouse_area_name,
            sku: items.sku_code + " - " + items.item_name,
            batchExternal: items.batch_external + " / " + this.formatDate(items.expired_date),
            dateIn: this.formatDate(items.date_in),
            hu: items.unit,
            availableQty: items.qty,
            availableQtyUom: items.qty_uom,
            newLines: items.line.map(line => ({
              newUnit: line.new_unit,
              newQty: line.new_qty,
              newQtyUom: line.new_qty_uom,
              newBatchExternal: line.new_batch_external,
              newExpiredDate: this.formatDate(line.new_expired_date)
            }))
          }));

        } else {
          this.$vs.notify({
            title: "Error",
            text: resp.message,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check"
          });
        }
        this.$vs.loading.close();
      });
    },
    handleShowAttachment(file) {
      window.open(file, "_blank");
    },
    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD') : '';
    },
  },
  mounted() {
    if (this.id) {
      this.getData();
    }
  },
};
</script>
